import {Component, OnInit} from '@angular/core';
import {activateAccessForm} from '../../../Assets/angular/assets/data/forms/activate_access';
import {ClientService} from '../../services/client.service';

@Component({
    selector: 'app-activate-access',
    templateUrl: './activate-access.component.html',
    styleUrls: ['./activate-access.component.scss']
})

export class ActivateAccessComponent implements OnInit {

    activateAccessForm: Array<object>;
    textMessage: string;
    modalId: string;

    constructor(public clientService: ClientService) {
        this.activateAccessForm = activateAccessForm;
        this.textMessage = 'El documento no pertenece a ningún cliente';
        this.modalId = 'modal-error-dni';
    }

    ngOnInit(): void {
    }

}
